// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../node_modules/@rsbuild/core/compiled/css-loader/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/@rsbuild/core/compiled/css-loader/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.azhpNqO17428_x3QnR_6{padding:0 24px 24px}.GM6rXdT1aVAdeN_CC_o8{align-items:center;gap:4px;margin-top:2px;margin-left:8px;display:flex}.x73jZov9Xu8Kp3c7R3as{align-items:center;gap:8px;margin-top:12px;display:flex}.c8Bc8MmiCEXCty06kBJB{align-items:center;gap:8px;margin-left:auto;display:flex}.bTR7hz90C1ooVZQzTlXR{font-size:14px}.bTR7hz90C1ooVZQzTlXR input{height:18px}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"wrap": `azhpNqO17428_x3QnR_6`,
	"helper": `GM6rXdT1aVAdeN_CC_o8`,
	"actions": `x73jZov9Xu8Kp3c7R3as`,
	"actionsRight": `c8Bc8MmiCEXCty06kBJB`,
	"textField": `bTR7hz90C1ooVZQzTlXR`
};
export default ___CSS_LOADER_EXPORT___;
